module.exports = __webpack_public_path__ + "img/Phone_08.76c97aba.jpg";